<template>
  <card header='Bars'>
    <svg-h-bar :series="series" />
  </card>
</template>

<script>
import Card from '@/components/charts/dev/Card.vue'
import SvgHBar from '@/components/charts/svg/HBar.vue'

export default {
  components: {
    Card,
    SvgHBar
  },
  data () {
    return {
      series: [
        {
          label: 'Скубатова Елена Владимировна',
          values: [1233423, 1233423]
        },
        {
          label: 'Торопова Екатерина Юрьевна',
          values: [1233423, 1233423]
        },
        {
          label: 'Лазарева Марина Николаевна',
          values: [1103423, 1103423]
        },
        {
          label: 'Рыбникова Татьяна Юрьевна',
          values: [1003423, 1003423, 1003423]
        },
        {
          label: 'Воронович Галина Юрьевна',
          values: [903423, 903423, 903423]
        },
        {
          label: 'Коннова Ирина Вячеславовна',
          values: [803423, 803423]
        },
        {
          label: 'Седова Евгения Владимировна',
          values: [753423, 753423, 753423, 753423]
        },
        {
          label: 'Ласточкина Елена Валерьевна',
          values: [703423, 923, 423]
        },
        {
          label: 'Кубинцева Елена Александровна',
          values: [663423, 63423, 363423]
        },
        {
          label: 'Елагин Михаил Владимирович',
          values: [603423, 923, 503423]
        },
        {
          label: 'Кучеренко Евгений Дмитриевич',
          values: [783423, 903]
        },
        {
          label: 'Метропольская Ольга Евгеньевна',
          values: [1383423, 383423]
        },
        {
          label: 'Соловьева Анна Серьгеевна',
          values: [483423, 6723]
        },
        {
          label: 'Мартынов Кирилл Константинович',
          values: [83423, 13423]
        },
        {
          label: 'Иванов Кирилл Иванович',
          values: [183423, 43423]
        }
      ]
    }
  }
}
</script>
